export default __webpack_public_path__ + "static/media/main-banner-4.39864c1a.svg";